import { render, staticRenderFns } from "./ElectronicBilling.vue?vue&type=template&id=2eaf209c"
import script from "./ElectronicBilling.vue?vue&type=script&lang=js"
export * from "./ElectronicBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports